"use strict";

var _Array$from = require("@babel/runtime-corejs2/core-js/array/from");
var _Symbol = require("@babel/runtime-corejs2/core-js/symbol");
var _Symbol$iterator = require("@babel/runtime-corejs2/core-js/symbol/iterator");
var _Array$isArray = require("@babel/runtime-corejs2/core-js/array/is-array");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.processNewCaptions = exports.getSpeakerFromProxyOrStore = exports.getSpeaker = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/map"));
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && o[_Symbol$iterator] || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var getSpeaker = exports.getSpeaker = function getSpeaker(members) {
  var csis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (0, _values.default)(members).find(function (member) {
    var _member$participant$s;
    var memberCSIs = (_member$participant$s = member.participant.status.csis) !== null && _member$participant$s !== void 0 ? _member$participant$s : [];
    return csis.some(function (csi) {
      return memberCSIs.includes(csi);
    });
  });
};
var getSpeakerFromProxyOrStore = exports.getSpeakerFromProxyOrStore = function getSpeakerFromProxyOrStore(_ref) {
  var _meetingMember$partic, _meetingMember$partic2;
  var csisKey = _ref.csisKey,
    meetingMembers = _ref.meetingMembers,
    transcriptData = _ref.transcriptData;
  var speaker = {
    speakerId: '',
    name: ''
  };
  var needsCaching = false;
  if (csisKey && transcriptData.speakerProxy[csisKey]) {
    speaker = transcriptData.speakerProxy[csisKey];
    return {
      speaker: speaker,
      needsCaching: needsCaching
    };
  }
  var meetingMember = getSpeaker(meetingMembers, [csisKey]);
  speaker = {
    speakerId: (_meetingMember$partic = meetingMember === null || meetingMember === void 0 ? void 0 : meetingMember.participant.person.id) !== null && _meetingMember$partic !== void 0 ? _meetingMember$partic : '',
    name: (_meetingMember$partic2 = meetingMember === null || meetingMember === void 0 ? void 0 : meetingMember.participant.person.name) !== null && _meetingMember$partic2 !== void 0 ? _meetingMember$partic2 : ''
  };
  needsCaching = true;
  return {
    speaker: speaker,
    needsCaching: needsCaching
  };
};
var processNewCaptions = exports.processNewCaptions = function processNewCaptions(_ref2) {
  var data = _ref2.data,
    meeting = _ref2.meeting;
  var transcriptId = data.transcriptId;
  var transcriptData = meeting.transcription;
  var _data$transcripts = data.transcripts,
    transcripts = _data$transcripts === void 0 ? [] : _data$transcripts;
  var transcriptsPerCsis = new _map.default();
  var _iterator = _createForOfIteratorHelper(transcripts),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _transcriptsPerCsis$g, _transcriptsPerCsis$g2;
      var transcript = _step.value;
      var text = transcript.text,
        currentSpokenLanguage = transcript.transcript_language_code,
        _transcript$csis = (0, _slicedToArray2.default)(transcript.csis, 1),
        csisMember = _transcript$csis[0];
      var newCaption = "".concat((_transcriptsPerCsis$g = (_transcriptsPerCsis$g2 = transcriptsPerCsis.get(csisMember)) === null || _transcriptsPerCsis$g2 === void 0 ? void 0 : _transcriptsPerCsis$g2.text) !== null && _transcriptsPerCsis$g !== void 0 ? _transcriptsPerCsis$g : '', " ").concat(text).trim();
      transcriptsPerCsis.set(csisMember, _objectSpread(_objectSpread({}, transcript), {}, {
        text: newCaption,
        currentSpokenLanguage: currentSpokenLanguage
      }));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var interimTranscriptionIds = [];
  var _iterator2 = _createForOfIteratorHelper(transcriptsPerCsis),
    _step2;
  try {
    var _loop = function _loop() {
      var _meeting$transcriptio, _meeting$transcriptio2, _meeting$transcriptio3, _meeting$transcriptio4, _data$transcripts$;
      var _step2$value = (0, _slicedToArray2.default)(_step2.value, 2),
        key = _step2$value[0],
        value = _step2$value[1];
      var _getSpeakerFromProxyO = getSpeakerFromProxyOrStore({
          meetingMembers: meeting.members.membersCollection.members,
          transcriptData: transcriptData,
          csisKey: key
        }),
        needsCaching = _getSpeakerFromProxyO.needsCaching,
        speaker = _getSpeakerFromProxyO.speaker;
      var speakerId = speaker.speakerId;
      var interimId = "".concat(transcriptId, "_").concat(speakerId);
      if (needsCaching) {
        transcriptData.speakerProxy[key] = speaker;
      }
      var captionData = {
        id: interimId,
        isFinal: data.isFinal,
        translations: value.translations,
        text: value.text,
        currentCaptionLanguage: ((_meeting$transcriptio = meeting.transcription) === null || _meeting$transcriptio === void 0 ? void 0 : (_meeting$transcriptio2 = _meeting$transcriptio.languageOptions) === null || _meeting$transcriptio2 === void 0 ? void 0 : _meeting$transcriptio2.currentCaptionLanguage) || value.currentSpokenLanguage,
        currentSpokenLanguage: ((_meeting$transcriptio3 = meeting.transcription) === null || _meeting$transcriptio3 === void 0 ? void 0 : (_meeting$transcriptio4 = _meeting$transcriptio3.languageOptions) === null || _meeting$transcriptio4 === void 0 ? void 0 : _meeting$transcriptio4.currentSpokenLanguage) || ((_data$transcripts$ = data.transcripts[0]) === null || _data$transcripts$ === void 0 ? void 0 : _data$transcripts$.transcript_language_code),
        timestamp: value === null || value === void 0 ? void 0 : value.timestamp,
        speaker: speaker
      };
      if (!data.isFinal) {
        var interimTranscriptIndex = transcriptData.captions.findIndex(function (transcript) {
          return transcript.id === interimId;
        });
        if (interimTranscriptIndex !== -1) {
          transcriptData.captions.splice(interimTranscriptIndex, 1);
        }
        interimTranscriptionIds.push(interimId);
      } else {
        transcriptData.interimCaptions[transcriptId].forEach(function (innerInterimId) {
          var interimTranscriptIndex = transcriptData.captions.findIndex(function (transcript) {
            return transcript.id === innerInterimId;
          });
          if (interimTranscriptIndex !== -1) {
            transcriptData.captions.splice(interimTranscriptIndex, 1);
          }
        });
        delete transcriptData.interimCaptions[transcriptId];
        captionData.id = transcriptId;
      }
      transcriptData.captions.push(captionData);
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  transcriptData.interimCaptions[transcriptId] = interimTranscriptionIds;
};
//# sourceMappingURL=voicea-meeting.js.map
